import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams,AlertController ,MenuController} from 'ionic-angular';
import { Storage } from '@ionic/storage'
import { AuthService } from '../../providers/auth-service'
import { MODO_DESCONECTADO,VERSION,NOMBRE_VERSION,DESCRIPCION_VERSION } from "../../config/url.servicio"
import { CompaniasProvider } from '../../providers/companias/companias'
import { CorreoPage } from '../../pages/correo/correo'
import { CuadreCajaDiarioValoresPorDenominacionPage } from '../../pages/cuadre-caja-diario-valores-por-denominacion/cuadre-caja-diario-valores-por-denominacion'
import { ParametrosGeneralesPage } from '../../pages/parametros-generales/parametros-generales'
import { ParametrosCajaPage } from '../../pages/parametros-caja/parametros-caja'
import { DevolverVentasPage } from '../devolver-ventas/devolver-ventas';
import { DevolverAbonosPage } from '../devolver-abonos/devolver-abonos';
import { CuadreCajaDiarioDomiciliosPage } from '../cuadre-caja-diario-domicilios/cuadre-caja-diario-domicilios';

@IonicPage()
@Component({
  selector: 'page-seguridad',
  templateUrl: 'seguridad.html',
  providers: [ AuthService ]
})
export class SeguridadPage {
  datosPaginaSeguridad:any[] = []
  datosPaginaSeguridadReal:any[] = []
  recorrerVal:any[]
  nombreCompaniaHeader:any=""
  nombreCargoHeader:any=""
  constructor(public navCtrl: NavController, public navParams: NavParams,
    public alertControllers:AlertController,
    public storages:Storage,
    public auth: AuthService,
    public servicioCompania:CompaniasProvider,
    public menuControllers:MenuController) {
    if(!MODO_DESCONECTADO){
      this.servicioCompania.devolverVarios(['nombreCompania','nombreCargo'])
      .then((val)=>{
        if(val){
          this.nombreCompaniaHeader = val['nombreCompania']
          this.nombreCargoHeader = val['nombreCargo']
        }
      })

      this.datosPaginaSeguridad = []
      this.datosPaginaSeguridad = [
        // { "titulo":"Procesos","id":1},
          { "titulo":"Seguridad","id":2},
          { "titulo":"Utilidades","id":3}
      ]

      this.datosPaginaSeguridadReal = [
      //  {  "titulo":"Correos","id":1,"nombre":"CorreoPage","ruta":"CorreoPage",
      //   "imagen":"https://res.cloudinary.com/drqk6qzo7/image/upload/v1534611819/seguridad-min_dwzsgg.jpg","icon":"mail-open"},
       {  "titulo":"Cierre caja","id":2,"nombre":"CuadreCajaDiarioValoresPorDenominacionPage","ruta":"CuadreCajaDiarioValoresPorDenominacionPage",
        "imagen":"https://res.cloudinary.com/drqk6qzo7/image/upload/v1534611819/seguridad-min_dwzsgg.jpg","icon":"closed-captioning"},
        {  "titulo":"Cierre domicilios","id":2,"nombre":"CuadreCajaDiarioDomiciliosPage","ruta":"CuadreCajaDiarioDomiciliosPage",
          "imagen":"https://res.cloudinary.com/drqk6qzo7/image/upload/v1534611819/seguridad-min_dwzsgg.jpg","icon":"closed-captioning"},
        {  "titulo":"Parametros generales","id":2,"nombre":"ParametrosGeneralesPage","ruta":"ParametrosGeneralesPage",
        "imagen":"https://res.cloudinary.com/drqk6qzo7/image/upload/v1534611819/seguridad-min_dwzsgg.jpg","icon":"build"},
       {  "titulo":"Parametros Caja","id":2,"nombre":"ParametrosCajaPage","ruta":"ParametrosCajaPage",
         "imagen":"https://res.cloudinary.com/drqk6qzo7/image/upload/v 1534611819/seguridad-min_dwzsgg.jpg","icon":"clipboard"},
         {  "titulo":"Devolver factura","id":3,"nombre":"DevolverVentasPage","ruta":"DevolverVentasPage",
         "imagen":"https://res.cloudinary.com/drqk6qzo7/image/upload/v 1534611819/seguridad-min_dwzsgg.jpg","icon":"arrow-back"},
         {  "titulo":"Devolver abono","id":3,"nombre":"DevolverAbonosPage","ruta":"DevolverAbonosPage",
         "imagen":"https://res.cloudinary.com/drqk6qzo7/image/upload/v1534611819/seguridad-min_dwzsgg.jpg","icon":"return-left"}

      ]

     }else{

       this.navCtrl.setRoot('PrincipalPage');
     }

  }

  ionViewDidLoad() {
  }
  abrirPaginaDesdeMenu(ruta:any,nombre:any){
    this.storages.get('rut').then((val)=>{
      this.recorrerVal = JSON.parse(val)
      let data = 0

      for(var i=0;i < this.recorrerVal.length;i++){
        if(this.recorrerVal[i].nombre == nombre){
          data = -1
        }
      }

      if(data!=-1){
        this.mostrarMensajes('No tiene permisos para ingresar','Verifique..')
      }else{
       this.irArutas(ruta)

      }
    })
  }
  irArutas(ruta:any){
    switch(ruta){
      case "CorreoPage":
      this.navCtrl.push(CorreoPage)
      this.menuControllers.close()
      break;
      case "CuadreCajaDiarioValoresPorDenominacionPage":
      this.navCtrl.push(CuadreCajaDiarioValoresPorDenominacionPage)
      this.menuControllers.close()
      break;
      case "ParametrosGeneralesPage":
      this.navCtrl.push(ParametrosGeneralesPage)
      this.menuControllers.close()
      break;
      case "ParametrosCajaPage":
      this.navCtrl.push(ParametrosCajaPage)
      this.menuControllers.close()
      break;
      case "DevolverVentasPage":
      this.navCtrl.push(DevolverVentasPage)
      this.menuControllers.close()
      break;
      case "DevolverAbonosPage":
      this.navCtrl.push(DevolverAbonosPage)
      this.menuControllers.close()
      break;
      case "CuadreCajaDiarioDomiciliosPage":
      this.navCtrl.push(CuadreCajaDiarioDomiciliosPage)
      this.menuControllers.close()
      break;




    }
  }
  mostrarMensajes(mensaje,advertencia) {
    let alert = this.alertControllers.create({
      title: advertencia,
      subTitle: mensaje,
      buttons: ['Ok']
    });
    alert.present()
  }

  cerrarSession(){
    this.auth.logout()
    this.navCtrl.setRoot('LoginPage');
  }
}



// WEBPACK FOOTER //
// ./src/pages/seguridad/seguridad.ts